<template>
    <main class="landing-container">
        <section class="slogan">
            <div class="container1366">
                <div class="slogan-left">
                    <h1 class="main-title">{{ $t("lp-collector-reg01") }} <div>{{ $t("lp-collector-reg02") }}</div></h1>
                    <div class="box-container">
                        <div class="box-container-row">
                            <div class="box-container-row-item1">
                                <div class="box-container-text">100+</div>
                                <div class="box-container-text1">{{ $t("lp-collector-reg03") }}</div>
                            </div>
                            <div class="box-container-row-item2">
                                <div class="box-container-text">17%+</div>
                                <div class="box-container-text1">{{ $t("lp-collector-reg04") }}</div>
                            </div>
                        </div>
                        <div class="box-container-divider"></div>
                        <div class="box-container-row box-container-row2">
                            <div class="box-container-row-item3">
                                <div class="box-container-text">30,000+</div>
                                <div class="box-container-text1">{{ $t("lp-collector-reg05") }}</div>
                            </div>
                            <div class="box-container-row-item4">
                                <div class="box-container-text">€ 2,800</div>
                                <div class="box-container-text1">{{ $t("lp-collector-reg06") }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="slogan-right">
                    <div class="reg-form-title">{{ $t("lp-collector-reg07") }}</div>
                    <div class="reg-inner">
                        <v-flex class="reg-field-wrapper">
                            <v-text-field
                                id="regFName"
                                ref="regFName"
                                v-model="regFName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regFName.$error"
                                :label="$t('myprofile1')"
                                :autofocus="true"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="reg-field-wrapper">
                            <v-text-field
                                v-model="regLName"
                                class="email-input"
                                :rules="[rules.required]"
                                :error="$v.regLName.$error"
                                :label="$t('myprofile2')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="reg-field-wrapper">
                            <v-text-field
                                ref="email"
                                v-model="regEmail"
                                class="email-input"
                                :rules="[rules.required, rules.emailValid]"
                                :label="$t('email')"
                            ></v-text-field>
                        </v-flex>
                        <v-flex class="reg-field-wrapper">
                            <v-text-field
                                ref="regPassword"
                                v-model="regPassword"
                                :append-icon="secureRegPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                :rules="[rules.required, rules.min]"
                                :type="secureRegPassword ? 'password' : 'text'"
                                name="input-10-1"
                                @click:append="secureRegPassword = !secureRegPassword"
                                v-on:keyup.enter="registration"
                                :label="$t('password')"
                            >
                            </v-text-field>
                        </v-flex>
                        <v-checkbox
                            v-model="checked18"
                            :label="$t('register-confirm18')"
                            class="check-terms"
                        ></v-checkbox>
                        <v-checkbox
                            v-model="checkedTerms"
                            class="check-terms"
                        >
                            <div slot="label">
                                {{ $t('register-terms') }}
                            </div>
                        </v-checkbox>
                        <v-checkbox
                            v-model="checkedNews"
                            :label="$t('register-news')"
                            class="check-terms"
                        ></v-checkbox>
                        <v-flex>
                            <v-btn class="submit login-submit" v-on:click="registration">{{ $t('new-home42') }}</v-btn>
                        </v-flex>
                        <v-flex v-if="errorMsg !== ''">
                            <div class="errors-container2">
                                <p>{{errorMsg}}</p>
                            </div>
                        </v-flex>
                    </div>
                </div>
            </div>
        </section>
        <section class="second-section">
            <div class="container1366 padding120 padding80">
                <div class="second-section-left">
                    <div class="second-section-left-row second-section-left-row1">{{ $t("lp-collector-reg08") }}</div>
                    <div class="second-section-left-row second-section-left-row2">{{ $t("lp-collector-reg09") }}</div>
                    <div class="second-section-left-row second-section-left-row3">{{ $t("lp-collector-reg10") }}</div>
                    <div class="second-section-left-row second-section-left-row4">{{ $t("lp-collector-reg11") }}</div>
                    <div class="second-section-left-row second-section-left-row5">{{ $t("lp-collector-reg12") }}</div>
                </div>
                <div class="second-section-right"></div>
            </div>
        </section>
    </main>
</template>

<script>
    import {email, minLength, required} from "vuelidate/lib/validators";
    import {mapActions} from "vuex";
    import {AAuth} from "@/store/actions";

    export default {
        name: "LpWineInvestorsRegistration",
        head: {
            title: 'Wine Investors Registration | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-landing-investor-reg'
            }
        },
        validations: {
            regFName: {
                required
            },
            regLName: {
                required
            },
            regEmail: {
                required,
                email
            },
            regPassword: {
                required,
                minLength: minLength(8)
            }
        },
        data() {
            return {
                regEmail: '',
                regPassword: '',
                regFName: '',
                regLName: '',
                countryId: 224,
                isLoading: false,
                checkedTerms: false,
                checked18: false,
                checkedNews: true,
                secureRegPassword: true,
                reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                errorMsg: '',
            }
        },
        computed: {
            rules() {
                return {
                    required: value => !!value || this.$i18n.t('required', this.$i18n.locale),
                    min: value => value.length >= 8 || this.$i18n.t('required1', this.$i18n.locale),
                    emailValid: value => this.isEmailValid(value) || 'Invalid email'
                }
            }
        },
        methods: {
            ...mapActions({
                signup: AAuth.REG_USER
            }),
            isEmailValid: function (email) {
                return this.reg.test(email)
            },
            goSection(val) {
                setTimeout(() => {
                    this.$nuxt.$emit("goToSection", val);
                }, 500)
                this.$router.push(this.localePath({path: '/wine-academy'}));

            },
            registration() {
                this.$v.regFName.$touch();
                this.$v.regLName.$touch();
                if (this.regEmail && this.regPassword && !this.$v.regEmail.$invalid && !this.$v.regPassword.$invalid && !this.$v.regFName.$invalid && !this.$v.regLName.$invalid) {
                    if (this.checkedTerms && this.checked18) {
                        this.isLoading = true;
                        let payload = {
                            email: this.regEmail,
                            password: this.regPassword,
                            confirmPassword: this.regPassword,
                            firstname: this.regFName,
                            lastname: this.regLName,
                            countryId: this.countryId,
                            phoneNumber: '+ 1',
                            name: '',
                            enabledNotification: this.enabledNotification === true ? 1 : 0,
                            newsletter: this.checkedNews
                        };
                        this.signup(payload).then(res => {
                            if (res.statusCode === 400) {
                                this.isLoading = false;
                                this.errorMsg = 'Email is already in use.';
                            } else {
                                if (res.reasonPhrase === "Created") {
                                    localStorage.setItem('user_email', this.regEmail);
                                    this.$router.push(this.localePath({path: '/registration-pending'}));
                                }

                                this.$gtm.push({ event: "registration" });
                                window.fbq('track', 'CompleteRegistration');
                                window.uetq = window.uetq || [];
                                window.uetq.push("event", "signup", {});
                                this.$gtm.push({
                                    'event': 'UETRegistration',
                                    'ecomm_pagetype': 'conversion'
                                });
                            }
                        }).catch(err => {
                            this.isLoading = false;
                            if (err.status === 400) {
                                this.errorMsg = 'Email is already in use.';
                            } else {
                                this.errorMsg = 'Please try again.';
                            }
                        })
                    } else {
                        this.errorMsg = 'You must agree with the terms of service and confirm that you are at least 18 years old.';
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .slogan {
        height: 688px;
        position: relative;
        background: url('../assets/landing/investor/hero1.png') no-repeat center top;
        background-size: cover;
    }
    .container1366 {
        position: relative;
        max-width: 1366px;
        margin: 0 auto;
        padding: 0 15px;
        box-sizing: border-box;
        z-index: 1;
    }
    .slogan .container1366 {
        display: flex;
        align-items: center;
    }
    .padding120 {
        padding: 0 120px;
    }
    .padding40 {
        padding-top: 40px;
        padding-bottom: 40px;
    }
    .padding80 {
        padding-top: 80px;
        padding-bottom: 80px;
    }
    .slogan-left {
        display: flex;
        background: linear-gradient(135deg, rgba(33, 104, 148, 0.60) 0%, rgba(6, 23, 33, 0.60) 100%);
        flex-direction: column;
        align-items: flex-start;
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        height: 688px;
        padding: 50px 120px;
    }
    .slogan-right {
        display: flex;
        background: rgba(0, 40, 64, 0.80);
        gap: 24px;
        flex: 1 0 0;
        align-self: stretch;
        height: 688px;
        padding: 0 120px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    @media (min-width: 1170px) and (max-width: 1441px) {
        .slogan-left {
            padding: 40px;
        }
        .slogan-right {
            padding: 0 40px;
        }
    }
    h1.main-title {
        color: #FFF;
        font-family: Montserrat;
        font-size: 42px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    h1.main-title div {
        color: #8CD0FA;
    }
    .box-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
        min-height: 411px;
    }
    .box-container-row {
        display: flex;
        align-items: center;
        align-self: stretch;
        border-radius: 8px 8px 0 0;
        background: rgba(0, 40, 64, 0.50);
    }
    .box-container-row2 {
        border-radius: 0 0 8px 8px;
        min-height: 179px;
    }
    .box-container-divider {
        display: flex;
        height: 1px;
        align-items: flex-start;
        gap: 10px;
        align-self: stretch;
        background: rgba(255, 255, 255, 0.24);
    }
    .box-container-row-item1 {
        display: flex;
        padding: 72px 0 24px 16px;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
        border-right: 0.5px solid rgba(255, 255, 255, 0.24);
        background: url('../assets/landing/investor_registration/globe.png') no-repeat 16px 16px;
        background-size: 48px;
    }
    .box-container-row-item2 {
        display: flex;
        padding: 72px 0 0 24px;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
        border-left: 0.5px solid rgba(255, 255, 255, 0.24);
        background: url('../assets/landing/investor_registration/chart.png') no-repeat 16px 16px;
        background-size: 48px;
    }
    .box-container-row-item3 {
        display: flex;
        padding: 72px 0 16px 16px;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
        border-right: 0.5px solid rgba(255, 255, 255, 0.24);
        background: url('../assets/landing/investor_registration/users.png') no-repeat 16px 16px;
        background-size: 48px;
    }
    .box-container-row-item4 {
        display: flex;
        padding: 72px 0 16px 24px;
        flex-direction: column;
        align-items: flex-start;
        flex: 1 0 0;
        align-self: stretch;
        border-left: 0.5px solid rgba(255, 255, 255, 0.24);
        background: url('../assets/landing/investor_registration/currency.png') no-repeat 16px 16px;
        background-size: 48px;
    }
    .box-container-text {
        align-self: stretch;
        color: #FFF;
        font-family: Montserrat;
        font-size: 32px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
    }
    .box-container-text1 {
        align-self: stretch;
        color: #FFF;
        font-family: Montserrat;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        text-transform: capitalize;
    }
    .reg-form-title {
        align-self: stretch;
        color: #FFF;
        text-align: center;
        font-family: Montserrat;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        text-transform: capitalize;
    }
    .reg-field-wrapper {
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.16);
        background: rgba(255, 255, 255, 0.24);
        height: 54px;
        padding: 0 16px;
        align-items: center;
        margin-bottom: 16px;
    }
    .landing-container .submit {
        border-radius: 8px;
        border: 2px solid #ffffff;
        background: #ffffff;
        padding: 6px 16px;
        display: block;
        width: 100%;
        color: #004F7F;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-top: 24px;
        height: 49px;
    }
    .reg-inner {
        width: 100%;
    }
    .second-section {
        background: #F5F5F5;
    }
    .second-section .container1366 {
        display: flex;
        gap: 40px;
    }
    .second-section-left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 40px;
        flex: 1 0 0;
        align-self: stretch;
    }
    .second-section-right {
        display: flex;
        align-items: flex-end;
        flex: 1 0 0;
        background: url('../assets/landing/investor_registration/laptop.png') no-repeat center;
        background-size: contain;
    }
    .second-section-left-row {
        flex: 1 0 0;
        color: #002840;
        font-family: Montserrat;
        font-size: 22px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        padding-left: 40px;
        min-height: 32px;
        display: flex;
        align-items: center;
    }
    .second-section-left-row1 {
        background: url('../assets/landing/investor_registration/currency2.png') no-repeat left top;
        background-size: 32px;
    }
    .second-section-left-row2 {
        background: url('../assets/landing/investor_registration/package.png') no-repeat left top;
        background-size: 32px;
    }
    .second-section-left-row3 {
        background: url('../assets/landing/investor_registration/chart2.png') no-repeat left top;
        background-size: 32px;
    }
    .second-section-left-row4 {
        background: url('../assets/landing/investor_registration/spider.png') no-repeat left top;
        background-size: 32px;
    }
    .second-section-left-row5 {
        background: url('../assets/landing/investor_registration/check.png') no-repeat left top;
        background-size: 32px;
    }
    @media (min-width: 1367px) {
        .slogan .container1366 {
            max-width: 100%;
            padding: 0;
        }
        .reg-inner, .reg-form-title {
            padding: 0 110px;
        }
    }
    @media (max-width: 1171px) {
        .slogan-left {
            padding: 40px;
        }
        .slogan .container1366 {
            padding: 0;
        }
        .slogan-right {
            padding: 0 40px;
        }
        .second-section .container1366.padding120 {
            padding-left: 40px;
            padding-right: 40px;
        }
        .second-section-left-row {
            font-size: 18px;
        }
    }
    @media (width: 768px) {
        .slogan-left {
            padding: 24px;
        }
        .slogan .container1366 {
            padding: 0;
        }
        .slogan-right {
            padding: 0 24px;
        }
        .second-section .container1366.padding120 {
            padding-left: 24px;
            padding-right: 24px;
        }
        .second-section-left-row,
        .box-container-text1 {
            font-size: 14px;
        }
        .box-container-text, h1.main-title {
            font-size: 24px;
        }
        h1.main-title {
            margin-top: 16px;
        }
    }
    @media (max-width: 767px) {
        .slogan .container1366 {
            flex-direction: column;
        }
        .slogan-left {
            padding: 24px 16px;
            gap: 16px;
        }
        .slogan-right {
            padding: 0 16px;
        }
        h1.main-title {
            font-size: 28px;
            margin-bottom: 0;
        }
        .box-container {
            min-height: auto;
        }
        .box-container-text {
            font-size: 22px;
        }
        .box-container-text1 {
            font-size: 12px;
        }
        .box-container-row-item1,
        .box-container-row-item2,
        .box-container-row-item3,
        .box-container-row-item4 {
            background-size: 32px;
            padding-top: 56px;
        }
        .box-container-row2 {
            min-height: 97px;
        }
        .reg-form-title {
            font-size: 22px;
            margin-top: 24px;
        }
        .slogan {
            height: auto;
        }
        .landing-container .submit {
            margin-bottom: 24px;
        }
        .second-section .container1366.padding120 {
            padding: 210px 16px 24px;
            background: url('../assets/landing/investor_registration/laptop.png') no-repeat center 24px;
            background-size: auto 170px;
        }
        .second-section-left {
            gap: 24px;
        }
        .second-section-right {
            display: none;
        }
        .second-section-left-row {
            font-size: 14px;
        }
    }
</style>
<style>
    .page-landing-investor-reg .v-main {
        padding-top: 80px !important;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field {
        padding-top: 0;
        margin-top: 0;
        height: 52px;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-input__slot {
        margin-bottom: 0;
        height: 53px;
    }
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active{
        -webkit-background-clip: text;
        -webkit-text-fill-color: rgba(255, 255, 255, 0.64) !important;
        transition: background-color 5000s ease-in-out 0s;
        box-shadow: none;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field input {
        border: 0 !important;;
        background-color: transparent !important;
        max-height: 52px;
        height: 42px;
        color: rgba(255, 255, 255, 0.64) !important;
    }
    .page-landing-investor-reg .mdi-checkbox-blank-outline::before {
        color: rgba(255, 255, 255, 0.64) !important;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field > .v-input__control > .v-input__slot:after,
    .page-landing-investor-reg .reg-field-wrapper .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
        border-color: transparent !important;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field .v-label {
        color: rgba(255, 255, 255, 0.64);
        font-family: Montserrat;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 22px;
        top: 10px;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field.v-input--is-focused .v-label {
        color: rgba(255, 255, 255, 0.64) !important;
        top: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Montserrat;
        font-size: 12px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }
    .page-landing-investor-reg .reg-field-wrapper .v-text-field .v-input__append-inner {
        margin-top: 13px;
    }
    .page-landing-investor-reg .v-input--selection-controls .v-input__slot {
        margin-bottom: 0;
    }
    .page-landing-investor-reg .reg-inner .theme--light.v-label {
        color: white;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px;
    }
    .v-application .primary--text.v-label {
        color: rgba(255, 255, 255, 0.64);
    }
    .page-landing-investor-reg .check-terms .v-messages {
        display: none;
    }
    .page-landing-investor-reg .theme--light.v-btn.v-btn--has-bg.login-submit span {
        color: #004F7F;
        font-family: Montserrat;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        text-transform: capitalize;
        letter-spacing: initial;
    }
    .page-landing-investor-reg .v-application .primary--text {
        color: rgba(255, 255, 255, 0.24) !important;
        caret-color: rgba(255, 255, 255, 0.24) !important;
    }
</style>
